import React from "react";
import TextArea from "src/components/Shared/Forms/Inputs/TextArea";

export default function HtmlAndRichTextEditor({ htmlContent = "", setHtmlContent = () => {} }) {
  return (
    <div className="relative">
      <div className="h-[600px] lg:h-[800px]">
        <TextArea
          name="html"
          type="code"
          autoComplete="off"
          value={htmlContent}
          rows={10}
          onChange={(e) => setHtmlContent(e.target.value)}
        />
      </div>
    </div>
  );
}
